module.exports = __webpack_public_path__ + "img/brifecase-cross.4ba7da3a.svg";